import {takeEvery} from 'redux-saga/effects';
import createAsyncSaga from 'lib/createAsyncSaga';
import {getEditangleInfo} from 'lib/api/getEditangle';
import {getEditangleAction, GET_EDITANGLE} from 'modules/getEditangle/actions';

const getEditangleSaga = createAsyncSaga(getEditangleAction, getEditangleInfo);

export function* GetEditangleSaga() {
  yield takeEvery(GET_EDITANGLE, getEditangleSaga);
}
